<template>
  <b-container>
    <div v-if="isHorizontalPlan" class="row d-flex align-items-center flex-column">
      <EventsControllers v-slot="{ controllers: { clickSubscribeHorizontal } }">
        <PricesHorizontal
          :is-loading="loading"
          :prices="customPlans"
          :button-text="buttonText"
          :button-text-free-trial="$t('plans.common.cards.try')"
          :primary-color="planPrimaryColor"
          :secondary-color="planSecondaryColor"
          :terciary-color="planTerciaryColor"
          :quaternary-color="planQuaternaryColor"
          :bottom-text="''"
          :bottom-link="''"
          :icon="horizontalIconProps"
          :background-image="horizontalBackgroundProps"
          @subscribe="({ price }) => clickSubscribeHorizontal(price)"
        >
          <template #bottom-content>
            <div v-if="contentBelow" v-html="contentBelow"></div>
          </template>
        </PricesHorizontal>
      </EventsControllers>
    </div>
    <div v-else>
      <PurchaseFlow
        v-if="loading || customPlans.length"
        :prismic-props="prismicProps"
        :custom-plans="customPlans"
        :show-plans="true"
        :plans-new-page="true"
        :plans-page="true"
      />
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { parsePlanAreasSlug } from '~/utils/common.js';
export default {
  components: {
    PurchaseFlow: () => import('@/components/PurchaseFlow'),
    PricesHorizontal: () => import('@/components/Prices/PricesHorizontal'),
    EventsControllers: () => import('@/components/Prices/EventsControllers')
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      planPrimaryColor: 'var(--exp-color)',
      planSecondaryColor: 'var(--exp-color)',
      planTerciaryColor: 'var(--gray)',
      planQuaternaryColor: 'var(--white)',
      customPlans: [],
      backgroundColor: '#FFF',
      contentBelow: '',
      loading: true,
      horizontalPlans: [
        'Lifetime plans',
        'Affiliate lifetime plans',
        'KDP affiliate plans',
        'KDP plans'
      ],
      prismicProps: {}
    };
  },
  computed: {
    ...mapGetters('plan-areas', [
      'parsePlans',
      'parsePlansDataVertical',
      'parsePlansDataAnnual',
      'getButtonText'
    ]),
    isHorizontalPlan() {
      return this.getPlanLayoutType() === 'horizontal';
    },
    horizontalIconProps() {
      return {
        url: !this.loading && this.customPlans[0].icon
      };
    },
    horizontalBackgroundProps() {
      return {
        url: !this.loading && this.customPlans[0].background
      };
    },
    buttonText() {
      return this.getButtonText(
        this.$t('purchase.plans.common.suscribe'),
        this.$t('plans.common.cards.upgrade')
      );
    }
  },
  async created() {
    const { slice_label } = this.slice;
    const {
      primary: { configuracion }
    } = this.slice;
    const slug = parsePlanAreasSlug(configuracion);
    try {
      const { primary } = this.slice;

      this.prismicProps = {
        alternativeLayout: slice_label === 'layout_2',
        description: primary.description,
        switchImageAnnual: primary.switch_image_annual,
        switchImageMonthly: primary.switch_image_monthly,
        primaryIds: [1, 2, 3],
        showSwitch: false,
        switchOnAnnual: false
      };

      this.loading = true;
      const { firstPlanArea, secondPlanArea } = await this.$store.dispatch(
        'plan-areas/LOAD_PRICE_AREA_GROUP',
        slug
      );
      if (!firstPlanArea) {
        this.loading = false;
        this.customPlans = [];
        return;
      }

      const hasFirstAreaPlans = firstPlanArea?.plans?.length;
      const hasSecondAreaPlans = secondPlanArea?.plans?.length;
      if (this.isHorizontalPlan) {
        if (hasFirstAreaPlans) {
          this.customPlans = this.parsePlans(firstPlanArea.plans);
        }
      } else {
        const isAnnually = firstPlanArea.plans[0].isAnnually;
        this.customPlans = hasSecondAreaPlans
          ? this.parsePlansDataVertical(firstPlanArea.plans, secondPlanArea.plans)
          : isAnnually
          ? this.parsePlansDataAnnual(firstPlanArea.plans)
          : this.parsePlans(firstPlanArea.plans);
        this.prismicProps.showSwitch = hasFirstAreaPlans && hasSecondAreaPlans;
        this.prismicProps.switchOnAnnual = Boolean(hasSecondAreaPlans || isAnnually);
      }
      this.loading = false;
    } catch (error) {
      console.error('Error on get data for Fixed Plans', error);
    }
  },
  methods: {
    getPlanLayoutType() {
      const {
        primary: { configuracion }
      } = this.slice;
      const isHorizontal = this.horizontalPlans.includes(configuracion);
      return isHorizontal ? 'horizontal' : 'vertical';
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-plan-container {
  @include md {
    width: 80% !important;
  }
}
</style>
